import { initLoadable } from '@/store/utils'
import type { Loadable } from '@/store/utils'

export type TGiftTier = 'gift-1-month' | 'gift-3-month'

export type TGiftStatus = 'purchased' | 'sent' | 'redeemed'

// This is WIP - aligns with in-flight server-nest work just to unblock client flow
export type TGift = {
    id: string
    stripeCheckoutSessionId: string
    tier: TGiftTier
    status: TGiftStatus
    /** Whoever holds this can redeem the gift, so treat it as a credential. */
    redemptionToken: string
    createdAt: string
    updatedAt: string

    // Absent rather than null: unset fields do not exist on the record
    purchasedByEmail?: string
    /** Only once the purchaser sends the gift rather than forwarding it. */
    invitedEmail?: string
    /** Only once someone has claimed it. */
    redeemedBy?: string
    priceCentsAtPurchase?: number
    currency?: string
}

/**
 * What the server will tell an anonymous holder of a redemption token.
 *
 * Deliberately thin — no purchaser, no price. `giftId` is handed back here and
 * nowhere else: the redeem link carries the token alone, so the gift's own id
 * never travels in a URL, and redemption presents both.
 */
export type TRedeemableGift = {
    giftId: string
    tier: TGiftTier
    /** False once claimed, so the client can say so rather than offer it. */
    isRedeemable: boolean
}

type TRGiftState = {
    validGift: Loadable<TRedeemableGift | null>
    redemptionToken: string | null
    giftError: string | null
    hasSeenRedeemGiftNotification: boolean
    isShowingRedeemGiftModal: boolean
}

export const getInitialGiftState = (): TRGiftState => {
    return {
        validGift: initLoadable(null),
        redemptionToken: null,
        giftError: null,
        hasSeenRedeemGiftNotification: false,
        isShowingRedeemGiftModal: false,
    }
}

const moduleState = getInitialGiftState()

export default moduleState
